import { EntryMode } from '../../../../@types/types'
import { FlowInformation } from '../../../../@types/flow-types'
import { Attachment as AiExtractionAttachment } from '../../../../api/aiDataExtraction/types'
import { getPageTitle, tracking, trackingOnPageLoad } from '../../../../tracking/tracking'

const AI_DATA_EXTRACTION_OVERLAY_PAGE = 'documents_overlay'

export const getAiDataExtractionOverlayPageTitle = (
  flowInformation?: FlowInformation,
  entryMode?: EntryMode | string
) => `${getPageTitle(flowInformation?.metaData, entryMode)}.${AI_DATA_EXTRACTION_OVERLAY_PAGE}`

export const trackAiDataExtractionBannerClick = (flowInformation?: FlowInformation, entryMode?: EntryMode | string) => {
  tracking({
    eventName: 'upload_documents_click',
    flowInformation,
    entryMode,
  })
}

export const trackAiDataExtractionOverlayPageView = (
  flowInformation?: FlowInformation,
  entryMode?: EntryMode | string
) => {
  trackingOnPageLoad(
    flowInformation,
    entryMode,
    undefined,
    undefined,
    getAiDataExtractionOverlayPageTitle(flowInformation, entryMode)
  )
}

export const trackAiDataExtractionOverlayClick = (
  eventName: string,
  flowInformation?: FlowInformation,
  entryMode?: EntryMode | string
) => {
  tracking({
    eventName,
    flowInformation,
    entryMode,
    pageTitle: getAiDataExtractionOverlayPageTitle(flowInformation, entryMode),
  })
}

export const getAiDataExtractionProcessedTypes = (attachments: AiExtractionAttachment[]) => {
  const attachmentTypes = new Set(attachments.map((attachment) => attachment.type))
  const processedTypes = [
    attachmentTypes.has('IMAGE') ? 'photos' : undefined,
    attachmentTypes.has('FLOOR_PLAN') ? 'fp' : undefined,
    attachmentTypes.has('ENERGY_CERTIFICATE') ? 'ec' : undefined,
  ].filter((value): value is string => Boolean(value))

  return processedTypes.join(',')
}

export const trackAiDataExtractionProcessingSuccess = (
  attachments: AiExtractionAttachment[],
  flowInformation?: FlowInformation,
  entryMode?: EntryMode | string
) => {
  const processedTypes = getAiDataExtractionProcessedTypes(attachments)

  if (!processedTypes) {
    return
  }

  tracking({
    eventName: 'processing_successful',
    flowInformation,
    entryMode,
    pageTitle: getAiDataExtractionOverlayPageTitle(flowInformation, entryMode),
    eventParameter: processedTypes,
  })
}
